export const baseURL = "https://khulo.lumos.com.ge";

export const formHeaders = {
    'Accept': 'application/json',
    'Content-Type': 'application/x-www-form-urlencoded',
};